import React, { useCallback, useEffect, useState } from "react";
import { Layout, Card, Row, Col, Typography, message } from "antd";
import { ClockCircleOutlined, CalendarOutlined } from "@ant-design/icons";
import Sidebar from "../components/Sidebar";
import AppHeader from "../components/Header";
import axiosInstance from "../api/axiosInstance";
import moment from "moment";
import AppFooter from "../components/Footer";

const { Content } = Layout;
const { Title, Text, Link } = Typography;

const Dashboard = () => {
  const [meetings, setMeetings] = useState([]);
  const [nextMeeting, setNextMeeting] = useState(null);
  const [countdown, setCountdown] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchMeetings = useCallback(async () => {
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user")); // Ambil user login dari localStorage
      if (!user) {
        message.error("User tidak ditemukan, silakan login kembali.");
        return;
      }

      // API hanya mengambil meeting yang sesuai dengan user login
      const res = await axiosInstance.get(`/meeting/user/${user}`);
      setMeetings(res.data);
      checkUpcomingMeetings(res.data);
    } catch (error) {
      message.error("Gagal mengambil data meeting");
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchMeetings(); // Panggil fetch data pertama kali

    const interval = setInterval(() => {
      fetchMeetings();
    }, 60000); // Cek setiap 1 menit

    return () => clearInterval(interval); // Bersihkan interval saat unmount
  }, [fetchMeetings]);

  const checkUpcomingMeetings = (meetings) => {
    const now = moment();
    const upcomingMeetings = meetings.filter((meeting) =>
      moment(meeting.waktu_meeting).isAfter(now)
    );

    if (upcomingMeetings.length > 0) {
      const nearestMeeting = upcomingMeetings.sort((a, b) =>
        moment(a.waktu_meeting).diff(moment(b.waktu_meeting))
      )[0];

      setNextMeeting(nearestMeeting);
      updateCountdown(nearestMeeting.waktu_meeting);
    }
  };

  const updateCountdown = (meetingTime) => {
    const interval = setInterval(() => {
      const now = moment();
      const meetingMoment = moment(meetingTime);
      const duration = moment.duration(meetingMoment.diff(now));

      if (duration.asSeconds() <= 0) {
        setCountdown("Meeting sedang berlangsung!");
        clearInterval(interval);
        return;
      }

      setCountdown(
        `${duration.hours()} jam ${duration.minutes()} menit ${duration.seconds()} detik`
      );
    }, 1000);

    return () => clearInterval(interval);
  };

  const renderMeetingLink = (link) => {
    const isUrl = link.startsWith("http://") || link.startsWith("https://");
    return isUrl ? (
      <Link
        href={link}
        target="_blank"
        style={{ color: "#1890ff", fontWeight: "bold" }}
      >
        {link}
      </Link>
    ) : (
      <Text>{link}</Text>
    );
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <AppHeader />
        <Content style={{ margin: "20px", padding: "20px" }}>
          <Title
            level={2}
            style={{ textAlign: "center", marginBottom: "30px" }}
          >
            DAILY MEETING APPS
          </Title>

          <Row gutter={[24, 24]} justify="center">
            {/* Card Total Meeting */}
            <Col xs={24} sm={12} md={10} lg={8}>
              <Card
                bordered={false}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "280px",
                  textAlign: "center",
                  background: "#f5f7fa",
                  borderRadius: "10px",
                  padding: "20px",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <CalendarOutlined
                  style={{ fontSize: "48px", color: "#1890ff" }}
                />
                <Title level={4} style={{ marginTop: "10px" }}>
                  TOTAL MEETING BULAN INI
                </Title>
                <Text style={{ fontSize: "32px", fontWeight: "bold" }}>
                  {meetings.length}
                </Text>
              </Card>
            </Col>

            {/* Card Countdown Meeting Berikutnya */}
            <Col xs={24} sm={12} md={10} lg={8}>
              <Card
                bordered={false}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "280px",
                  textAlign: "center",
                  background: "#f5f7fa",
                  borderRadius: "10px",
                  padding: "20px",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <ClockCircleOutlined
                  style={{ fontSize: "48px", color: "#faad14" }}
                />
                <Title level={4} style={{ marginTop: "10px" }}>
                  NEXT MEETING
                </Title>
                {nextMeeting ? (
                  <>
                    <Text strong style={{ fontSize: "18px" }}>
                      {nextMeeting.nama_project}
                    </Text>
                    <br />
                    <Text type="secondary" style={{ fontSize: "16px" }}>
                      {moment(nextMeeting.waktu_meeting).format(
                        "DD MMM YYYY, HH:mm"
                      )}
                    </Text>
                    <br />
                    {renderMeetingLink(nextMeeting.link_meeting)}
                    <br />
                    <Text
                      style={{
                        fontSize: "20px",
                        color: "#fa541c",
                        fontWeight: "bold",
                        marginTop: "10px",
                        display: "inline-block",
                      }}
                    >
                      {countdown}
                    </Text>
                  </>
                ) : (
                  <Text style={{ fontSize: "16px", color: "#8c8c8c" }}>
                    Tidak ada meeting dalam waktu dekat
                  </Text>
                )}
              </Card>
            </Col>
          </Row>
        </Content>
        <AppFooter />
      </Layout>
    </Layout>
  );
};

export default Dashboard;
